let initialValues = {
  treatmentReceived: '',
};

export default initialValues;
